export default "__VITE_ASSET__f464f53b__"